// react-tooltip centers the tooltip on its trigger (the whole full-width button);
// the upsell tooltip should point at the crown badge instead, so shift it by the
// crown's horizontal offset from the trigger's center. react-tooltip@3 calls
// overridePosition with two different argument orders (showTooltip vs
// updatePosition), so resolve the trigger/tooltip nodes by scanning the args
// rather than relying on a fixed position (mirrors SubscribersOnlyHover).
export const centerTooltipOnCrown = (position, ...rest) => {
  const nodes = rest.filter((arg) => arg && typeof arg.getBoundingClientRect === 'function')
  const tooltip = nodes.find((el) => el.classList && el.classList.contains('cgt-tooltip'))
  const trigger = nodes.find((el) => el !== tooltip)
  const crown = trigger?.querySelector?.('.paid-feature-badge')
  if (!tooltip || !trigger || !crown) {
    return position
  }
  const triggerRect = trigger.getBoundingClientRect()
  const crownRect = crown.getBoundingClientRect()
  const delta = (crownRect.left + (crownRect.width / 2)) - (triggerRect.left + (triggerRect.width / 2))
  return { left: position.left + delta, top: position.top }
}
